// i want drop down for saparatly call api for excel and pdf download on right side od download button

import React, { useContext, useEffect, useState } from "react";
import { Box, Button, Checkbox, CircularProgress, Dialog, DialogContent, FormControl, FormControlLabel, FormGroup, IconButton, InputLabel, MenuItem, Select, TextField, Typography, Fab, DialogActions, Tabs, Tab, Autocomplete } from "@mui/material";
import Tooltip from "@mui/material/Tooltip";
import { Check as CheckIcon, Clear as ClearIcon, Close, CropSharp, Details, Work } from "@mui/icons-material";
import { CloseOutlined } from "@mui/icons-material";
import { Stack } from "@mui/material";
import styled from "styled-components";
import OpaqueLoading from "../opaqueLoading/opaqueLoading";
import { DataGrid, GridToolbarColumnsButton, GridToolbarContainer, GridToolbarDensitySelector, GridToolbarExport, GridToolbarFilterButton } from "@mui/x-data-grid";
import { AuthContext } from "../contextAPI/ContextAPI";
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
const isMobile = window.innerWidth < 900;
const ModalHeaderContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 15px;
  padding: 10px;
`;
const TableContainer = styled.div`
  // height: calc(
  //   100vh - ${isMobile ? "106px - 20px - 82.23px" : "100px - 20px - 23.77px"}
  // );
  width: ${isMobile ? "100%" : "98%"};
  border: solid 1px lightGrey;
  border-radius: 8px;
  margin-left:${isMobile ? "0px" : "10px"};
  margin-bottom:${isMobile ? "0px" : "10px"};

`;
const TabsContainer = styled.div`
  ${isMobile && `
    height: calc(100vh - 176px - 20px - 43.77px);
  `}
`
const StyledTabs = styled(Tabs)`
  border-bottom: solid 1px lightGrey;
`;
const Input = styled.input`
  display: none;
`;
const StaffMovementReportModal = ({ onClose, status }) => {
    const [tabValue, setTabValue] = useState(0);
    const [loading, setLoading] = useState(false)
    const [rm, setRm] = useState("")
    const [rsm, setRsm] = useState("")
    const [asm, setAsm] = useState("")
    const [rsms, setRsms] = useState([]);
    const [allUsers, setAllUsers] = useState([]);
    const [asms, setAsms] = useState([]);
    const [rms, setRms] = useState([]);
    const [userData, setUserData] = useState(JSON.parse(localStorage.getItem('storedUserData')).user)
    // const [startDate, setStartDate] = useState('');
    // const [endDate, setEndDate] = useState('');
    const today = new Date().toISOString().split("T")[0];
    const [startDate, setStartDate] = useState(today);
    const [endDate, setEndDate] = useState(today);
    const [selectedFormat, setSelectedFormat] = useState("excel"); // "excel" or "pdf"
    const [remark, setRemark] = useState("")


    useEffect(() => {
        if (userData?.role.toLowerCase().includes('admin')) {
            getAllUsers()
        }
        if (userData?.role == 'rsm') {
            getUsers('rsm', userData?.id)
        }
        if (userData?.role == 'asm') {
            getUsers('asm', userData?.id)
        }
    }, [])

    async function getAllUsers() {
        let results = await window.Platform.database.fetchEmployees()
        setAllUsers(results?.data)
        setRsms(results?.data?.filter((ele) => ele.role.toLowerCase() == 'rsm'))
        setRms(results?.data?.filter((ele) => ele.role.toLowerCase() == 'se'))
        setAsms(results?.data?.filter((ele) => ele.role.toLowerCase() == 'asm'))
    }

    const downloadStaffMovement = async () => {
        if (startDate == "" || endDate == "") {
            return window.alert("Please select start date and end date");
        }
        setLoading(true);
        try {
            let data = {
                asm: userData?.role === 'asm' ? userData?.id : asm,
                rsm: userData?.role === 'rsm' ? userData?.id : rsm,
                ownerId: rm,
                startDate: startDate,
                endDate: endDate,
                remark: remark
            }
            let result = await window.Platform.database.exportData("/attendance/downloadStaffMovement",
                data
            )
            const blob = new Blob([result.data], {
                type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            });
            const now = new Date();
            const formattedDate = `${now.getDate().toString().padStart(2, '0')}-${(now.getMonth() + 1).toString().padStart(2, '0')}-${now.getFullYear()}`;
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", `staff_@_10AM_report_${formattedDate}.xlsx`);
            // link.setAttribute("download", "visit.xlsx");
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);
            setLoading(false);
        } catch (error) {
            setLoading(false);
      window.NotificationUtils.showError( "No Data Found");
            console.error("Export error:", error);
        }
    }

    const downloadStaffMovementPDF = async () => {
        if (startDate == "" || endDate == "") {
            return window.alert("Please select start date and end date");
        }
        setLoading(true);
        try {
            let data = {
                asm: userData?.role === 'asm' ? userData?.id : asm,
                rsm: userData?.role === 'rsm' ? userData?.id : rsm,
                ownerId: rm,
                startDate: startDate,
                endDate: endDate,
                remark: remark
            }
            let result = await window.Platform.database.exportData("/attendance/downloadStaffMovementPDF",
                data
            )
            const blob = new Blob([result.data], {
                type: "application/pdf",
            });
            const now = new Date();
            const formattedDate = `${now.getDate().toString().padStart(2, '0')}-${(now.getMonth() + 1).toString().padStart(2, '0')}-${now.getFullYear()}`;
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", `staff_@_10AM_report_${formattedDate}.pdf`);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);
            setLoading(false);
        } catch (error) {
            setLoading(false);
            console.error("Export error:", error);
        }
    }
    

    async function getUsers(role, id) {
        if (id != "") {
            let results = await window.Platform.database.getUsersBasedOnManager({ userId: id })
            if (role == 'rsm') {
                setAsms(results?.data)
                setRms(results?.data1)
            }
            if (role == 'asm') {
                setRms(results?.data)
            }
        } else {
            if (role == 'rsm') {
                setRm("")
                setAsm("")
                setRms(allUsers?.filter((ele) => ele.role == 'se'))
                setAsms(allUsers?.filter((ele) => ele.role == 'asm'))
            }
            if (role == 'asm') {
                setRm("")
                setRms(allUsers?.filter((ele) => ele.role == 'se'))
            }
        }
    }

    const renderContent1 = () => {
        return (
            <div style={{ overflowY: "auto" }}>
                <Stack direction={"row"} padding={2}>
                    {userData?.role.includes("admin") && (
                        <div className="col-md-4">
                            <FormControl fullWidth>
                                <InputLabel sx={{ fontWeight: 500 }}>Select HO</InputLabel>
                                <Select
                                    value={rsm}
                                    label="Select HO"
                                    onChange={(e) => {
                                        setRsm(e.target.value);
                                        getUsers("rsm", e.target.value);
                                        setAsm("");
                                        setRm("");
                                    }}
                                >
                                    <MenuItem value="">All</MenuItem>
                                    {rsms.map((role) => (
                                        <MenuItem key={role.id} value={role.id}>
                                            {role.name} - {role.username}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </div>
                    )}
                    {userData?.role !== "asm" && (
                        <div className="col-md-4">
                            <FormControl fullWidth>
                                <InputLabel sx={{ fontWeight: 500 }}>Select ARM</InputLabel>
                                <Select
                                    value={asm}
                                    label="Select ARM"
                                    onChange={(e) => {
                                        setAsm(e.target.value);
                                        getUsers("asm", e.target.value);
                                        setRm("");
                                    }}
                                >
                                    <MenuItem value="">All</MenuItem>
                                    {asms.map((role) => (
                                        <MenuItem key={role.id} value={role.id}>
                                            {role.name} - {role.username}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </div>
                    )}
                    <div className="col-md-4">
                        <FormControl fullWidth>
                            <InputLabel sx={{ fontWeight: 500 }}>Select RM</InputLabel>
                            <Select
                                value={rm}
                                label="Select RM"
                                onChange={(e) => setRm(e.target.value)}
                            >
                                <MenuItem value="">All</MenuItem>
                                {rms.map((role) => (
                                    <MenuItem key={role.id} value={role.id}>
                                        {role.name} - {role.username}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </div>
                </Stack>
                <Stack direction={"row"} padding={2}>
                    <div className="col-md-4">
                        <TextField
                            label="From Date"
                            type="date"
                            fullWidth
                            value={startDate}
                            onChange={(e) => setStartDate(e.target.value)}
                            InputLabelProps={{ shrink: true }}
                            inputProps={{
                                max: new Date().toISOString().split("T")[0], // disable future dates
                            }}
                        />
                    </div>
                    <div className="col-md-4">
                        <TextField
                            label="To Date"
                            type="date"
                            fullWidth
                            value={endDate}
                            onChange={(e) => setEndDate(e.target.value)}
                            InputLabelProps={{ shrink: true }}
                            inputProps={{
                                max: new Date().toISOString().split("T")[0], // disable future dates
                            }}
                        />
                    </div>
                         <div className="col-md-4">
                        <FormControl fullWidth>
                            <InputLabel sx={{ fontWeight: 500 }}>Select Status</InputLabel>
                            <Select
                                value={remark}
                                label="Select Status"
                                onChange={(e) => setRemark(e.target.value)}
                            >
                                <MenuItem value="">All</MenuItem>
                                    <MenuItem key={1} value={"Present"}> Present </MenuItem>
                                    <MenuItem key={1} value={"On Leave"}> On Leave </MenuItem>
                                    <MenuItem key={1} value={"No Update"}> No Update </MenuItem>
                                    <MenuItem key={1} value={"Present But No Visit"}> Present But No Visit </MenuItem>
                             
                            </Select>
                        </FormControl>
                    </div>
                </Stack>
                <div
                className="mb-5"
                    style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        gap: "10px",
                        padding: "20px",
                    }}
                >
                    <Button
                        variant="contained"
                        color="success"
                        startIcon={<FileDownloadIcon />}
                        sx={{ fontSize: "14px", borderRadius: "10px", width: "45%" }}
                        onClick={() =>
                            selectedFormat === "excel"
                                ? downloadStaffMovement()
                                : downloadStaffMovementPDF()
                        }
                    >
                        Download
                    </Button>

                    <FormControl
                        sx={{
                            width: "150px",
                            ml: 2,
                            "& .MuiOutlinedInput-root": {
                                borderRadius: "12px",
                                backgroundColor: "#f8f9fa",
                                fontWeight: 500,
                                "& fieldset": {
                                    borderColor: "#c4c4c4",
                                },
                                "&:hover fieldset": {
                                    borderColor: "#4caf50",
                                },
                                "&.Mui-focused fieldset": {
                                    borderColor: "#2e7d32",
                                    borderWidth: "2px",
                                },
                            },
                        }}
                    >
                        <InputLabel sx={{ fontWeight: 500 }}>Format</InputLabel>
                        <Select
                            value={selectedFormat}
                            onChange={(e) => setSelectedFormat(e.target.value)}
                            label="Format"
                            size="small"
                        >
                            <MenuItem value="excel">
                                <span role="img" aria-label="excel" style={{ marginRight: 8 }}>
                                    📊
                                </span>
                                Excel
                            </MenuItem>
                            <MenuItem value="pdf">
                                <span role="img" aria-label="pdf" style={{ marginRight: 8 }}>
                                    📄
                                </span>
                                PDF
                            </MenuItem>
                        </Select>
                    </FormControl>

                </div>

            </div>
        )
    }

    return (
        <Dialog disableEnforceFocus maxWidth="lg" fullWidth={true} open={true} >
            {loading && <OpaqueLoading />}
            <ModalHeaderContainer style={{ marginBottom: 2, paddingBottom: 3 }}>
                <Typography variant={isMobile ? "h6" : "h5"}>
                    Staff Movement Report
                </Typography>
                <IconButton onClick={onClose} >
                    <CloseOutlined />
                </IconButton>
            </ModalHeaderContainer>
            <TableContainer>
                <TabsContainer>
                    <StyledTabs
                        variant="fullWidth"
                        value={tabValue}

                        // onChange={ handleChangeTab}
                        indicatorColor="primary"
                        textColor="primary"
                    >

                        <Tab label="Staff Movement Report" />

                    </StyledTabs>
                    {renderContent1()}
                </TabsContainer>
            </TableContainer>
        </Dialog>
    );
};

export default StaffMovementReportModal;